unit AcademyListPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  WEBLib.Lists,
  Vcl.Controls,
  WEBLib.WebCtrls;

type
  TAcademyForm = class(TBaseListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetName: TStringField;
    MainDatasetEmail: TStringField;
    MainDatasetTelephone: TStringField;
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
    FBuildingQuery: Boolean;

  protected
    [async]
    procedure EditRecord(const ARecordId: string); async; override;

    procedure PrepareForm; override;

    procedure LoadData; override;
    procedure SearchData(const Value: string); override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  AcademyForm: TAcademyForm;

implementation

uses
  AcademyEditPage,
  MainDataModule,
  Web.StringUtils;

{$R *.dfm}

{ TAcademyForm }

procedure TAcademyForm.EditRecord(const ARecordId: string);
var
  AForm: TAcademyEditForm;

begin
  if ARecordId = ''  then
    MainDataset.Append
  else
    MainDataset.Locate('Id', ARecordId.ToInteger, []);

  AForm := TAcademyEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.IdField := FIdField;

    Await(TAcademyEditForm, AForm.Load());
    Await(AForm.InitForm);

    AForm.Dataset := MainDataset;

    Await(TModalResult, AForm.Execute);

  finally
    AForm.Free;
    AForm := nil;

  end;

end;

procedure TAcademyForm.LoadData;
begin
  StandardLoadData;

end;

procedure TAcademyForm.PrepareForm;
begin
  FIdField := 'Id';

  MainDataset.Connection := MainData.DataConnection;

end;

procedure TAcademyForm.SearchData(const Value: string);
var
  sQuery: string;
  sValue: string;

begin
  if Trim(Value) = '' then
  begin
    // use default searching mechanism if no data entered
    inherited;

  end
  else
  begin
    // don't build if already building
    if FBuildingQuery then
      Exit;

    FBuildingQuery := True;

    // determine query sql
    sValue := EscapeSingleQuotesFirebird(UpperCase(Trim(Value)));
    if ContainsAlpha(Value) then
      sQuery :=
        'contains(upper(Name), ''' + Copy(sValue, 1, 255) + ''')'
    else
      sQuery :=
        'Id eq ''' + sValue + ''''
      ;

    FGridPlugin.SetPreparedFilter(sQuery);

    FBuildingQuery := False;

  end;

end;

procedure TAcademyForm.WebFormShow(Sender: TObject);
begin
  inherited;
  cbPageSizeChange(cbPageSize);

end;

procedure TAcademyForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetName := TStringField.Create(Self);
  MainDatasetEmail := TStringField.Create(Self);
  MainDatasetTelephone := TStringField.Create(Self);

  DataTable.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetName.BeforeLoadDFMValues;
  MainDatasetEmail.BeforeLoadDFMValues;
  MainDatasetTelephone.BeforeLoadDFMValues;
  WebElementActionList1.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Name';
      Title := 'Name';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Email';
      Title := 'Email';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
      Width := 100;
    end;
    MainDataset.EntitySetName := 'Academy';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetName.SetParentComponent(MainDataset);
    MainDatasetName.Name := 'MainDatasetName';
    MainDatasetName.FieldName := 'Name';
    MainDatasetName.Size := 255;
    MainDatasetEmail.SetParentComponent(MainDataset);
    MainDatasetEmail.Name := 'MainDatasetEmail';
    MainDatasetEmail.FieldName := 'Email';
    MainDatasetEmail.Size := 75;
    MainDatasetTelephone.SetParentComponent(MainDataset);
    MainDatasetTelephone.Name := 'MainDatasetTelephone';
    MainDatasetTelephone.FieldName := 'Telephone';
    MainDatasetTelephone.Size := 25;
    WebElementActionList1.Actions.Clear;
    with WebElementActionList1.Actions.Add do
    begin
      Control := edSearch;
      Event := heKeypress;
      ID := 'SearchText';
      Name := 'TrapEnter';
      PreventDefault := False;
    end;
  finally
    DataTable.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetName.AfterLoadDFMValues;
    MainDatasetEmail.AfterLoadDFMValues;
    MainDatasetTelephone.AfterLoadDFMValues;
    WebElementActionList1.AfterLoadDFMValues;
  end;
end;

end.